import { createSlice } from '@reduxjs/toolkit';
import { LoginStateType } from 'src/types/login';

const initialState: LoginStateType = {
    logged: false,
    loading: false,
    error: false,
    loadingForgetPassword: false,
    successForgetPassword: false,
    errorForgetPassword: false,
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        loginFetch: (state, data) => {
            state.loading = true;
            state.error = false;
        },
        loginFetchSuccess: (state) => {
            state.logged = true;
            state.loading = false;
        },
        loginFetchFailure: (state, action) => {
            state.logged = false;
            state.loading = false;
            state.error = true;
        },
        forgetPasswordFetch: (state, data) => {
            state.loadingForgetPassword = true;
            state.successForgetPassword = false;
            state.errorForgetPassword = false;
        },
        forgetPasswordFetchSuccess: (state) => {
            state.loadingForgetPassword = false;
            state.successForgetPassword = true;
            state.errorForgetPassword = false;
        },
        forgetPasswordFetchFailure: (state, action) => {
            state.loadingForgetPassword = false;
            state.successForgetPassword = false;
            state.errorForgetPassword = true;
        },
        clearForgetPassword: (state) => {
            state.successForgetPassword = false;
            state.errorForgetPassword = false;
        },
        setLogged: (state, action) => {
            state.logged = action.payload;
        },
        logoutFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        logoutFetchSuccess: (state) => {
            state.logged = false;
            state.loading = false;
        },
        logoutFetchFailure: (state, action) => {
            state.logged = false;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    loginFetch,
    loginFetchSuccess,
    loginFetchFailure,
    forgetPasswordFetch,
    forgetPasswordFetchSuccess,
    forgetPasswordFetchFailure,
    clearForgetPassword,
    setLogged,
    logoutFetch,
    logoutFetchSuccess,
    logoutFetchFailure,
} = loginSlice.actions;

export default loginSlice.reducer;
